import { Component, OnInit } from '@angular/core';
import { User } from '../models/index';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.css']
})
export class MyaccountComponent implements OnInit {
  isLoggedIn: any;
  user: User;
  modalTitle: string = '';
  modalValue: string = '';
  activeTab: string = 'profile';
  emailInput: string = '';
  profileCompletion: number = 0;
  loggedInDevices: any[] = [];

  form = {
    first_name: '',
    last_name: '',
    email: '',
    id_number: ''
  };

  passwordForm = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };

  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;

  phoneNumber: string = '';

  constructor(private router: Router, private userService: UserService) {}

  fetchLoginHistory() {
    // Assuming you're storing user login history in `user.login_history`
    const loginHistory = this.user?.login_history || [];

    this.loggedInDevices = loginHistory.map((entry: any) => {
      return {
        deviceType: entry.device_info || 'Unknown Device',
        location: 'Nairobi', // Or parse from IP using a location service
        ipAddress: entry.ip_address,
        lastActive: this.formatDate(entry.login_time),
        isCurrent: this.isCurrentDevice(entry)
      };
    });
  }
  validateEmail(email: string): boolean {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString(); // You can customize this format
  }

  isCurrentDevice(entry: any): boolean {
    // Simple logic: match IP address and user agent
    const currentIp = sessionStorage.getItem('current_ip'); // You might fetch this on login
    const currentAgent = navigator.userAgent;

    return (
      entry.ip_address === currentIp &&
      (entry.device_info || '').includes(this.getBrowserName())
    );
  }

  getBrowserName(): string {
    const ua = navigator.userAgent;
    if (ua.includes('Chrome')) return 'Chrome';
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Safari')) return 'Safari';
    if (ua.includes('Edge')) return 'Edge';
    return 'Unknown';
  }
  ngOnInit(): void {
    this.isLoggedIn = localStorage.getItem('isLoggedIn');
  
    const userData = localStorage.getItem('user');
  
    if (this.isLoggedIn && userData) {
      this.user = new User().deserialize(JSON.parse(userData));
      this.populateFormFromUser();
    } else {
      this.router.navigateByUrl('/home');
    }
  
    this.calculateProfileCompletion();
    this.fetchLoginHistory();
  }
  

  populateFormFromUser(): void {
    if (this.user) {
      const nameParts = this.user.fullName?.split(' ') || [];
      this.form.first_name = nameParts[0] || '';
      this.form.last_name = nameParts[1] || '';
      this.form.email = this.user.email || '';
      this.form.id_number = this.user.id_number || '';
    }
  }

  calculateProfileCompletion(): void {
    const fields = [
      this.form.first_name,
      this.form.last_name,
      this.form.email,
      this.form.id_number,
      this.user?.phone_number
    ];
    const filled = fields.filter(f => f && f.toString().trim() !== '').length;
    const total = fields.length;
    this.profileCompletion = Math.round((filled / total) * 100);
  }

  scrollTo(section: string) {
    this.activeTab = section;
  }

  openModal(field: string) {
    this.modalTitle = field;
    this.modalValue = '';
    const modalElement = document.getElementById('buupassProfileModal');
    if (modalElement) {
      const bsModal = new bootstrap.Modal(modalElement);
      bsModal.show();
    }
  }

  submitProfile() {
    if (!this.form.first_name || !this.form.last_name ) {
      alert('First name and  Last name are required!');
      return;
    }

    this.userService.updateProfile(this.form).subscribe({
      next: (response: any) => {
        alert('Profile updated successfully!');
        const updatedUser = { ...this.user, ...this.form };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        const modalElement = document.getElementById('buupassProfileModal');
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          modalInstance.hide();
        }
        this.user = new User().deserialize(updatedUser);
        this.calculateProfileCompletion();
      },
      error: (error) => {
        console.error('Update failed:', error);
        alert('Failed to update profile. Please try again.');
      }
    });
  }

  submitEmail() {
    if (!this.emailInput || !this.validateEmail(this.emailInput)) {
      alert('Please enter a valid email.');
      return;
    }
  
    this.userService.updateProfile({ email: this.emailInput }).subscribe({
      next: (response: any) => {
        alert('Email updated successfully!');
        
        const updatedUser = { ...this.user, email: this.emailInput };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        this.user = new User().deserialize(updatedUser);
  
        const modalElement = document.getElementById('buupassEmailModal');
        if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          modalInstance?.hide();
        }
  
        this.calculateProfileCompletion();
      },
      error: (error) => {
        console.error('Email update failed:', error);
        alert('Failed to update email. Please try again.');
      }
    });
  }
  
  submitPassword() {
    const { oldPassword, newPassword, confirmPassword } = this.passwordForm;

    if (!oldPassword || !newPassword || !confirmPassword) {
      alert('Please fill all fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      alert('New passwords do not match.');
      return;
    }

    if (newPassword.length < 6) {
      alert('Password should be at least 6 characters.');
      return;
    }

    alert('Password changed successfully!');
    const modal = document.getElementById('buupassPasswordModal');
    if (modal) {
      const instance = bootstrap.Modal.getInstance(modal);
      instance.hide();
    }
    this.calculateProfileCompletion();
  }

  submitPhoneNumber() {
    const phoneRegex = /^[0-9]{9}$/;
    if (!phoneRegex.test(this.phoneNumber)) {
      alert('Please enter a valid 9-digit mobile number.');
      return;
    }

    const fullNumber = '+254' + this.phoneNumber;
    console.log('Saved phone number:', fullNumber);
    alert(`Mobile number ${fullNumber} saved successfully!`);
    const modalElement = document.getElementById('#buupassPhoneModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      modalInstance.hide();
    }
    this.calculateProfileCompletion();
  }

  logoutUser() {
    this.isLoggedIn = false;
    localStorage.setItem('isLoggedIn', this.isLoggedIn);
    localStorage.setItem('user', 'null');
    localStorage.setItem('token', 'null');
    localStorage.clear();
    this.router.navigate(['/home']);
  }
}